import React from 'react'
import classnames from 'classnames'

import { TtButton, TtIcon, TtButtonGroup, TtTooltip } from '@23/ui-react'

interface ToolbarFormattingButtonGroupProps {
  isBold: boolean
  isItalic: boolean
  isUnderline: boolean
  isLink: boolean
  onBold: () => void
  onItalic: () => void
  onUnderline: () => void
  onLinkClick: () => void
  handleMouseDown: (e: React.MouseEvent<HTMLTtButtonElement>) => void
}

const ToolbarFormattingButtonGroup = ({
  isBold,
  isItalic,
  isUnderline,
  isLink,
  onBold,
  onItalic,
  onUnderline,
  onLinkClick,
  handleMouseDown,
}: ToolbarFormattingButtonGroupProps) => {
  return (
    <TtButtonGroup className="description-toolbar-button-group">
      <TtTooltip content="Bold (Ctrl+B)" placement="top">
        <TtButton
          className={classnames({
            'description-toolbar-btn-active': isBold,
          })}
          color="secondary"
          variant={isBold ? 'default' : 'ghost'}
          size="small"
          onMouseDown={handleMouseDown}
          onClick={(e) => {
            e.preventDefault()
            onBold()
          }}
        >
          <TtIcon library="one/wysiwyg" name="bold" />
        </TtButton>
      </TtTooltip>
      <TtTooltip content="Italic (Ctrl+I)" placement="top">
        <TtButton
          className={classnames({
            'description-toolbar-btn-active': isItalic,
          })}
          color="secondary"
          variant={isItalic ? 'default' : 'ghost'}
          size="small"
          onMouseDown={handleMouseDown}
          onClick={(e) => {
            e.preventDefault()
            onItalic()
          }}
        >
          <TtIcon library="one/wysiwyg" name="italic" />
        </TtButton>
      </TtTooltip>
      <TtTooltip content="Underline (Ctrl+U)" placement="top">
        <TtButton
          className={classnames({
            'description-toolbar-btn-active': isUnderline,
          })}
          color="secondary"
          variant={isUnderline ? 'default' : 'ghost'}
          size="small"
          onMouseDown={handleMouseDown}
          onClick={(e) => {
            e.preventDefault()
            onUnderline()
          }}
        >
          <TtIcon library="one/wysiwyg" name="underline" />
        </TtButton>
      </TtTooltip>
      <TtTooltip content="Link (Ctrl+K)" placement="top">
        <TtButton
          className={classnames({
            'description-toolbar-btn-active': isLink,
          })}
          color="secondary"
          variant={isLink ? 'default' : 'ghost'}
          size="small"
          onMouseDown={handleMouseDown}
          onClick={(e) => {
            e.preventDefault()
            onLinkClick()
          }}
        >
          <TtIcon library="one/wysiwyg" name="link" />
        </TtButton>
      </TtTooltip>
    </TtButtonGroup>
  )
}

export { ToolbarFormattingButtonGroup }
